import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiService, toFormData, markAllAsDirty, uploadProgress, toResponseBody, requiredFileType, requiredFileSize } from 'src/app/_services/api.service';

@Component({
    selector: 'app-generalForm',
    templateUrl: './generalForm.component.html',
    styleUrls: ['./generalForm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralFormComponent {
  progress = 0;
  contactForm: any;
  success = false;
  @Input() hideAddressHeader = false;

  constructor( private http: HttpClient, private formBuilder: UntypedFormBuilder, private apiService: ApiService ) {
    this.contactForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.required],
      description: '',
      email: ['', Validators.required],
      file: ['', [requiredFileType(''), requiredFileSize(10000000)]],
      recaptchaReactive: ['', Validators.required]
    });
    // file: ['', requiredFileType('pdf')],
  }

  submit() {
    this.success = false;
    console.log(this.contactForm)
    if ( !this.contactForm.valid ) {
      markAllAsDirty(this.contactForm);
      return;
    }
    toFormData(this.contactForm.value)
    console.log(this.contactForm)

    this.apiService.sendForm(toFormData(this.contactForm.value,),'general').subscribe(res => {
      // console.log(res);
      this.progress = 0;
      this.success = true;
      this.contactForm.reset();
      console.log(this.contactForm);
    });

  }

  hasError( field: string, error: string ) {
    const control = this.contactForm.get(field);
    if(this.success)
      return false;
    return control.dirty && control.hasError(error);
  }

}

